const basePrefix = import.meta.env.VITE_APP_NAME;

// 商品菜单
const router = [
    {
        path: `${basePrefix}`,
        redirect: `${basePrefix}/shop`,
        meta: {
            title: '店铺管理'
        },
        children: [
            {
                path: 'violation',
                name: 'violation',
                component: () => import(/* webpackChunkName: "violation" */ '@/views/violation'),
                meta: {
                    title: '违规管理'
                }
            },
            {
                path: 'agreement/view',
                name: 'agreementView',
                component: () =>
                    import(
                        /* webpackChunkName: "storeAgreementAgreementView" */ '@/store/agreement/components/AgreementView'
                    ),
                meta: {}
            },
            {
                path: 'shop',
                name: 'shop',
                component: () => import(/* webpackChunkName: "demoList" */ '@/store/shop'),
                meta: {
                    title: '店铺信息设置',
                    // isHiddenForMenu: true, // 在菜单里不显示
                    isHiddenMenu: true // 隐藏菜单
                }
            },
            {
                path: 'upgradeDetail',
                component: () => import(/* webpackChunkName: "storeUpgradeDetail" */ '@/views/StoreUpgrade/detail.vue'),
                meta: {
                    title: '主体变更申请',
                    isHiddenMenu: true // 隐藏菜单
                }
            },
            // {
            //     path: 'setting',
            //     name: 'setting',
            //     component: () => import(/* webpackChunkName: "storeSettings" */ '@/store/setting'),
            //     meta: {
            //         title: '店铺设置',
            //         // isHiddenForMenu: true, // 在菜单里不显示
            //         isHiddenMenu: true // 隐藏菜单
            //     }
            // },
            {
                path: 'shopDecoration',
                name: 'shopDecoration',
                component: () => import(/* webpackChunkName: "shopDecoration" */ '@/views/shop-decoration/Index.vue'),
                meta: {
                    title: '店铺装修'
                }
            },
            {
                path: 'wechatCallon',
                name: 'wechatCallon',
                component: () => import(/* webpackChunkName: "storeShopDecoration" */ '@/store/wechatCallon'),
                meta: {
                    title: '微信账户',
                    // isHiddenForMenu: true, // 在菜单里不显示
                    isHiddenMenu: true // 隐藏菜单
                }
            },
            {
                path: 'freightInsurance',
                component: () =>
                    import(/* webpackChunkName: "freightInsurance" */ '@/views/freight-insurance/Index.vue'),
                meta: {
                    title: '运费险'
                }
            },
            {
                path: 'smallShopDecoration',
                name: 'smallShopDecoration',
                component: () =>
                    import(/* webpackChunkName: "smallShopDecoration" */ '@/views/small-shop-decoration/index.vue'),
                meta: {
                    title: '小店装修'
                }
            }
        ]
    }
];

export default router;
